<template>
    <div>
        <label class="block text-sm font-medium text-gray-700" for="reference_probe"> Temp Reference </label>
        <div class="mt-1">
            <select2 :close-on-select="true"
                     :match-alpha-numeric="true"
                     :multiple="false"
                     :options='referenceProbeInformation'
                     name="temp_reference_probe"
                     placeholder="Select Reference"
            ></select2>
        </div>
    </div>

    <div>
        <label class="block text-sm font-medium text-gray-700" for="reference_probe"> Humidity Reference </label>
        <div class="mt-1">
            <select2 :close-on-select="true"
                     :match-alpha-numeric="true"
                     :multiple="false"
                     :options='referenceProbeInformation'
                     name="humidity_reference_probe"
                     placeholder="Select Reference"
            ></select2>
        </div>
    </div>

    <div>
        <label class="block text-sm font-medium text-gray-700" for="reference_probe"> Co2 Reference </label>
        <div class="mt-1">
            <select2 :close-on-select="true"
                     :match-alpha-numeric="true"
                     :multiple="false"
                     :options='referenceProbeInformation'
                     name="co2_reference_probe"
                     placeholder="Select Reference"
            ></select2>
        </div>
    </div>

    <div>
        <label class="block text-sm font-medium text-gray-700" for="calibration_zone"> NIST Calibrated </label>
        <div class="mt-1">
            <!-- Span -->
            <toggle     v-model:value="isNist"
                        name="is_nist"></toggle>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import UndecoratedLink from "@/components/EnterpriseDashboard/undecorated-link.vue";
import Select2 from "@/components/elements/select2.vue";
import Toggle from "@/components/elements/toggle.vue";

export default {
    name: "AutomatedCalibrationSSeriesHTCo2",
    mixins: [SonicuCoreMixin, iconNamesMixin],
    components: {Toggle, Select2},
    emits: [],
    props: {
        referenceProbeInformation: {
            type: Object,
            default: () => []
        },
    },
    data() {
        return {
            isNist: true,
        }
    },
    created() {

    },
    mounted() {

    },
    methods: {},
    computed: {},
    watch: {},
}
</script>

<style scoped>

</style>